<template>
  <ExplorerLayout />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import ExplorerLayout from '@/components/explorer/ExplorerLayout.vue';
import { useExplorerStore } from '@/stores/explorerStore';

const explorerStore = useExplorerStore();

// Load data on mount
onMounted(async () => {
  await explorerStore.initialize();
});
</script>
